// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cef3483c","239":"90c20610","453":"6c14ce80","553":"8d90207d"}[chunkId] + ".chunk.js";
};